import { Close } from '@mui/icons-material';
import LayersIcon from '@mui/icons-material/Layers';
import { Dialog, IconButton } from '@mui/material';
import {
  DialogHeader,
  DialogList,
  DialogTitleText,
  PermissionRow,
  PermissionRowDescription,
  PermissionRowName,
  PermissionRowText,
  StyledSwitch,
} from './style';
import { PermissionGroup } from '../utils/groupPermissions';

interface Props {
  open: boolean;
  group: PermissionGroup | null;
  onClose: () => void;
  onChangeChecked: (id: string, status: boolean) => void;
}

export const PermissionGroupDialog = ({ open, group, onClose, onChangeChecked }: Props) => {
  return (
    <Dialog fullWidth maxWidth="sm" open={open} onClose={onClose}>
      <DialogHeader>
        <DialogTitleText>
          <LayersIcon sx={{ color: '#00AC47', fontSize: 22 }} />
          {group?.name}
        </DialogTitleText>
        <IconButton onClick={onClose} size="small" aria-label="close">
          <Close />
        </IconButton>
      </DialogHeader>
      <DialogList>
        {group?.permissions.map(permission => (
          <PermissionRow key={permission.id}>
            <PermissionRowText>
              <PermissionRowName>{permission.name}</PermissionRowName>
              {permission.description && <PermissionRowDescription>{permission.description}</PermissionRowDescription>}
            </PermissionRowText>
            <StyledSwitch
              checked={permission.assigned}
              onChange={event => onChangeChecked(permission.id, event.target.checked)}
              color="success"
            />
          </PermissionRow>
        ))}
      </DialogList>
    </Dialog>
  );
};
